import { gql } from "@apollo/client";

export const FETCH_SAVED_VIEWS_QUERY = gql`
  query ListSavedViews($folderId: UUID) {
    listSavedViews(folderId: $folderId) {
      id
      isSelected
      title
      columns
    }
  }
`;

export const EDIT_SAVED_VIEWS_QUERY = gql`
  mutation EditSavedViews($savedViewId: UUID!, $title: String!, $columns: [String]!) {
    editSavedViews(savedViewId: $savedViewId, title: $title, columns: $columns) {
      success
      savedView {
        id
        isSelected
        columns
        title
      }
    }
  }
`;

export const ADD_SAVED_VIEWS_QUERY = gql`
  mutation SaveSavedViews($folderId: UUID!, $title: String!, $columns: [String]!) {
    saveSavedViews(folderId: $folderId, title: $title, columns: $columns) {
      success
      savedView {
        id
        isSelected
        columns
        title
      }
    }
  }
`;

export const DELETE_SAVED_VIEWS_QUERY = gql`
  mutation DeleteSavedViews($savedViewId: UUID!) {
    deleteSavedViews(savedViewId: $savedViewId) {
      success
    }
  }
`;
